import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmModal = ({
  open,
  handleClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmColor = "#D32F2F",
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#081B44",
          color: "#fff",
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "18px" }}>
          {title}
        </Typography>

        <IconButton
          onClick={handleClose}
          disabled={loading}
          sx={{
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.35)",
            width: 30,
            height: 30,
            "&.Mui-disabled": {
              color: "rgba(255,255,255,0.3)",
              borderColor: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: 3 }}>
        <Typography
          sx={{
            color: "#475467",
            fontSize: "14px",
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            mt: 3,
            pt: 2,
            borderTop: "1px solid #E5E7EB",
          }}
        >
          <Button
            onClick={handleClose}
            disabled={loading}
            sx={{
              bgcolor: "#E5E7EB",
              color: "#0F1E3D",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:disabled": {
                opacity: 0.7,
              },
            }}
          >
            {cancelLabel}
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={loading}
            sx={{
              bgcolor: confirmColor,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": {
                bgcolor: confirmColor,
                filter: "brightness(0.92)",
              },
              "&:disabled": {
                bgcolor: confirmColor,
                opacity: 0.7,
                color: "#fff",
              },
            }}
          >
            {loading ? "Processing..." : confirmLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
